module.exports = "/_next/static/images/PrintablePreview1-2a46df8f4b819f64e7c6130994852772.png";